exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.presentation {\n    margin-top: 10px;\n    margin-bottom: 20px;\n}\n.project-carousel,\n.project-carousel .v-window__container,\n.project-carousel .v-image__image--cover,\n.project-carousel .v-carousel__item {\n    height: 100% !important;\n    max-width: 800px;\n}\n", ""]);

// exports
